import { ConfigType } from '../utils/requestAPI';

export type CreateBuildingDataType = {
  buildingName?: string;
  buildingAddress?: string;
  createdBy?: string;
  bluePrints: {
    bluePrintUrl?: string;
    title?: string;
    blueprintFile?: File;
  }[];
  notes?: string;
};

type GetBuildingsParamsType = {
  page?: number;
  limit?: number;
};
const buildingsApi = {
  // Implemented in index file of AddBuilding,
  createBuilding: (data: CreateBuildingDataType): ConfigType => {
    return {
      url: '/buildings',
      method: 'post',
      data: data,
    };
  },
  // Implemented in AddTechnicianJob of CreateNewBuilding,index of Building
  getBuildings: (params: GetBuildingsParamsType): ConfigType => {
    return {
      url: '/buildings',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'buildings.data' } },
    };
  },
  // Implemented in  index of ViewBuilding
  getBuildingsDetails: (id: string): ConfigType => {
    return {
      url: `/buildings/${id}`,
      method: 'get',
      config: { store: { action: 'set', key: 'buildingsDetails' } },
    };
  },
  updateBuilding: (id: string, data: CreateBuildingDataType): ConfigType => {
    return {
      url: `/buildings/${id}`,
      method: 'put',
      data: data,
    };
  },
  deleteBuilding: (id: string): ConfigType => {
    return {
      url: `/buildings/${id}`,
      method: 'delete',
    };
  },
};

export default buildingsApi;
